import { encrypt,
         decrypt } from './crypto';
const crypto = require('crypto');
const jwt = require('jsonwebtoken');



/***
 ***  ENCODE 11 DIGIT PHONE # TO 6 CHARS FOR ENCODE AND TRANSPORT
 ***
 ***  11 digit Decimal => 35 bit Hex => 6 char using  6bit-map-ASCII
 ***
 ***  countr_code+11 digit Decimal => 43 bit (8 + 35) Hex => 8 char 6bit-map-ASCII
 ***
 ***  6-BITS-ASCII ARRAY
 ***  --------------------------------
 ***  64 array = 6 bits
 ***  A-Z: 26
 ***  a-z: 26
 ***  0-9: 10  => 62
 ***  - _
 ***/

//const map="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.+";
const map="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ01";   // KLUDGE: 2 repeats
const mod = 6;
function computePhoneCode(phone) {
    const ph=Number.parseFloat(phone);
    const hex0=ph.toString(16);   // hex string
    const dec=parseInt(hex0, 16);  // hex string back to number
    const hex1=dec & 0x7fffffff;    // the non-sign portion
    const hex2=(dec - hex1) / 0x100000000;  // MSB sign bit

    var out="", val = [], shft = 0, nshft, leftb, bits;
    var mask = Math.pow(2, mod) - 1;
    var nph = ph, nph1

    //console.log("ph=",ph);
    //console.log("hex0="+hex0);
    //console.log("hex1="+hex1.toString(16)+" hex2="+hex2.toString(16));
    //console.log("hex1="+hex1+" hex2="+hex2);
    //console.log("dec="+dec);
    //console.log("    mask="+mask);

    for (var i = 0; nph >= mask; i++) {
        bits = nph & mask;
        nph = nph >>> mod;
    
        //console.log("bits="+bits.toString(16)+" nph="+nph+"  shft="+shft);
        shft += mod;
        val.unshift(bits);
    }

    //console.log("shft="+shft);
    leftb = 32 - shft;   // residual from right half
    nshft = shft - (32 - mod);
    //console.log("hex2="+hex2.toString(16)+" leftb="+leftb+" nph="+nph.toString(16));
    nph1 = ((hex2 << leftb) + (nph));      // add the sign bit back

    //console.log("nph1="+(nph1).toString(16)+" shft="+shft+" nshft="+nshft + " leftb="+leftb);
    val.unshift(nph1);

    for (var i =0; i < val.length; i++) {
        //console.log(i+": "+ val[i].toString(16)+" = "+map[val[i]]);
        out += map[val[i]];
    }

    //console.log("******Encode Phone Output="+out);
    return out;
}

// convert 6 char encoded phone # back to 10 digits
function revertPhoneCode(code) {
    var rmap=[], inp=[], result = 0.0;

    // initialize decoder string
    for (var i = 0; i < map.length; i++) {
        rmap[map[i]] = i;   // create reverse hash
    }

    // translate back to base-64 values
    for (var i = 0; i < code.length; i++) {
        inp.push(rmap[code[i]]);
        //console.log(i+": "+ code[i].toString(16)+" = "+rmap[code[i]].toString(16));
    }

    // reconstitude the original number
    for (var i = 0; i < inp.length; i++) {
        result = (result * Math.pow(2, mod))+ inp[i];
        //console.log(i+": result="+result.toString(16)+" inp="+inp[i].toString(16));
    }

    //console.log("result="+result.toString(16));
    //console.log("result="+result);

    return result.toString();
}


// take each char and reverse last bits so not in clear text
// a.com => %60%2Fbnl => a.com
function scrambleEmailCode(email) {
    var out=[], out1=email;

    for (var i = 0; i < email.length; i++) {
        var c = email.charCodeAt(i);
        var o = c ^ 0x01;       // inverse last bit
        out += String.fromCharCode(o);
        //console.log("c="+c+"  o="+o);
    }
    console.log("scrambleEmailCode.104:  out=",out, "  out1=",out1);
    if(typeof(out) == "string") {
        out1 = out.replace(/\$3G/g,'.');
    }
    return out1;
}

/*
* JWT generic token management
*
*/
// create auth token to REST server to verify user identity
// server sends back a session access token to be included with all REST calls
function makeJwtToken(email, key) {
    if(email == null) {
        console.log("make_auth_token: ERROR: Must have valid email!")
        return
    }

    var btime = Math.floor(Date.now() / 1000);     // has to be in seconds
    console.log("JWT.1: btime=", btime, " email=", email);

    var body = {
            "email": email,                             // clear text email to lookup uuid
            "iat": btime
        }
    
    var token = jwt.sign(body, key);
    console.log("JWT.3 token: "+token);
    
    return token;
}


/*
* JWT SPECIAL KOSMOS token 
*
*/
// create auth token to REST server to verify user identity
// server sends back a session access token to be included with all REST calls
function makeKosmosJwtToken(email, key) {
    if(email == null) {
        console.log("make_auth_token: ERROR: Must have valid email!")
        return
    }
    const PDKDF2_SALT = "kosmos world domination";

    var bkey = crypto.pbkdf2Sync(key, PDKDF2_SALT, 100, 32, 'sha1');  // extend private key to 32 bytes
    console.log("pbkdf2 key: "+key+"  bkey="+bkey.toString('hex')+" email="+email);
    const iv = crypto.randomBytes(16);  // random init vector salt, send with encrypt data

    var biv = Buffer.from(iv);
    var btime = Buffer.from(Date.now().toString());
    //var bemail = Buffer.from(email);

    const payload_obj = {
        "email": email,                              // email in encrypted payload
        "time": btime.toString('utf8'),              // current time to defeat copy cat
    }
    console.log("encrypt payload: "+JSON.stringify(payload_obj))
    var payload = JSON.stringify(payload_obj)
    var bpayload = encrypt(payload, bkey, biv);

    var body = {
            "email": email,                             // clear text email to lookup uuid
            "iv": iv.toString('hex'),                   // clear text encryption init vector
            "payload": bpayload.toString('utf8')        // encrypted payload
        }
        
    if (true) {
        var npayload = decrypt({'iv': biv.toString('hex'), 'data': bpayload.toString('utf8')}, bkey)
        console.log("KMOS.2 decrypted payload="+npayload);
    }
    
    var token = jwt.sign(body, bkey);
    console.log("KMOS.2 token: "+token);
    
    return token;
}





export { computePhoneCode, revertPhoneCode, scrambleEmailCode, makeKosmosJwtToken, makeJwtToken }